import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vue3Marquee from 'vue3-marquee'
// import { loadFonts } from './plugins/webfontloader'



// loadFonts()

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(Vue3Marquee)
  .mount('#app')
